import { Outlet } from "react-router-dom"
import SettingsNavBar from "~/components/Admin/Settings/components/SettingsNavBar"

type Props = React.HTMLAttributes<HTMLDivElement>

export const AdminSettingsLayout: React.FC<Props> = () => {
  return (
    <div className="flex flex-grow justify-center px-4 lg:px-16 xl:px-28 2xl:px-44 sm:pb-4 pb-0">
      <div className="w-full md:flex md:flex-row space-x-1.5">
        <SettingsNavBar onTabChange={() => { }} />
        <div className="w-full justify-center">
          <div className="mx-4 mb-48 md:mt-24">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  )
}
